
<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_xianlai.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_xianlai.png'
import list_img1 from '../../images/download/down-xl1.png'
import list_img2 from '../../images/download/down-xl2.png'
import list_img3 from '../../images/download/down-xl3.png'
import cut_img1 from '../../images/download/cut_xl1.jpg'
import cut_img2 from '../../images/download/cut_xl2.jpg'
import cut_img3 from '../../images/download/cut_xl3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来麻将',
                size:'77.83',
                load_count:'2372',
                desp:'闲来湖南麻将是一款休闲类棋牌游戏。时尚简约的棋牌画面，真人实时对战玩法，陪伴您快乐每一天。 真人实时对战玩法，陪伴您快乐每一天！玩法最全的地方转转麻将玩法！不能吃，是的不能吃，可碰可杠，可胡牌。杠到底玩到爽。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=hunan',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=hunan',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
